import { render, staticRenderFns } from "./SwipeCta.vue?vue&type=template&id=ea4aa2ec&scoped=true&"
import script from "./SwipeCta.vue?vue&type=script&lang=js&"
export * from "./SwipeCta.vue?vue&type=script&lang=js&"
import style0 from "./SwipeCta.vue?vue&type=style&index=0&id=ea4aa2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4aa2ec",
  null
  
)

export default component.exports